import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

const KEY = "pp_nudge_at";
const COOLDOWN_MS = 24 * 3600 * 1000;
const BIG_WIN = 2000; // coins gained in one refresh

export function nudgeAllowed() {
  const last = Number(localStorage.getItem(KEY) || 0);
  return Date.now() - last > COOLDOWN_MS;
}

export function fireInviteNudge(t, navigate, reason) {
  if (!nudgeAllowed()) return;
  localStorage.setItem(KEY, String(Date.now()));
  toast(t(`nudge_${reason}`), {
    description: t("nudge_desc"),
    icon: <Gift className="w-4 h-4 text-fuchsia-300" />,
    duration: 9000,
    action: { label: t("nav_invite"), onClick: () => navigate("/invite") },
  });
}

// Watches the wallet: a big single-step coin gain (win/jackpot) triggers the invite nudge once per day.
export default function ReferralNudge() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useT();
  const prev = useRef(null);

  useEffect(() => {
    const coins = user?.coins;
    if (typeof coins !== "number") return;
    if (prev.current !== null && coins - prev.current >= BIG_WIN && !location.pathname.startsWith("/invite") && !location.pathname.startsWith("/wallet")) {
      setTimeout(() => fireInviteNudge(t, navigate, "win"), 1800);
    }
    prev.current = coins;
  }, [user?.coins, location.pathname, navigate, t]);

  return null;
}
